import { stringify } from "query-string"

import { dhFoodsMain } from "./api"

const endpoint = "/sms-panel/subscription-admin"

const toQuery = queries =>
  stringify(queries, {
    skipEmptyString: true,
    skipNull: true
  })

export const getSubscriptionSmsTemplates = async queries => {
  const response = await dhFoodsMain.get(`${endpoint}/templates?${toQuery(queries)}`)

  return response.data
}

export const createSubscriptionSmsTemplate = async data => {
  const response = await dhFoodsMain.post(`${endpoint}/templates`, data)

  return response.data
}

export const reviewSubscriptionSmsTemplate = async (templateId, data) => {
  const response = await dhFoodsMain.patch(`${endpoint}/templates/${templateId}/review`, data)

  return response.data
}

export const getSubscriptionSmsAutomationRules = async queries => {
  const response =
    await dhFoodsMain.get(`${endpoint}/automation-rules?${toQuery(queries)}`)

  return response.data
}

export const reviewSubscriptionSmsAutomationRule = async (ruleId, data) => {
  const response =
    await dhFoodsMain.patch(`${endpoint}/automation-rules/${ruleId}/review`, data)

  return response.data
}

export const getSubscriptionBulkSmsRequests = async queries => {
  const response = await dhFoodsMain.get(`${endpoint}/bulk-requests?${toQuery(queries)}`)

  return response.data
}

export const getSubscriptionKavenegarAccountInfo = async () => {
  const response = await dhFoodsMain.get(`${endpoint}/kavenegar/account-info`)

  return response.data
}

export const approveSubscriptionBulkSmsRequest = async (requestId, data = {}) => {
  const response = await dhFoodsMain.post(`${endpoint}/bulk-requests/${requestId}/approve`, data)

  return response.data
}

export const rejectSubscriptionBulkSmsRequest = async (requestId, data = {}) => {
  const response = await dhFoodsMain.post(`${endpoint}/bulk-requests/${requestId}/reject`, data)

  return response.data
}
